// extracted by mini-css-extract-plugin
export default {"root":"TextArea_root__S8UGc","visuallyHidden":"TextArea_visuallyHidden__vmXjw"};